import { useForm } from "react-hook-form";
import { CompanyStampDetailDto } from "@/dto/CompanyStampDto";

/**
 * 도장 상세 정보 훅
 * @param companyStampInfo 도장 상세 정보
 * @returns methods, handleSubmit
 */
export default function useDetail(companyStampInfo: CompanyStampDetailDto) {
  // react-hook-form 초기화
  const methods = useForm({
    defaultValues: {
      // 기본 정보
      comId: companyStampInfo?.comId || "",
      comNm: companyStampInfo?.comNm || "",
      bizrno: companyStampInfo?.bizrno || "",
      rprsntvNm: companyStampInfo?.rprsntvNm || "",
      addr: companyStampInfo?.addr || "",
      dtlAddr: companyStampInfo?.dtlAddr || "",
      lon: companyStampInfo?.lon || "",
      lat: companyStampInfo?.lat || "",
      email: companyStampInfo?.email || "",
      telNum: companyStampInfo?.telNum || "",
      admNm: companyStampInfo?.admNm || "",

      // 구독 정보
      productNm: companyStampInfo?.productNm || "",
      subscriptionYn: companyStampInfo?.subscriptionYn || "N",
      subscriptionStat: companyStampInfo?.subscriptionStat || null,
      templateNm: companyStampInfo?.templateNm || "",
      templateId: companyStampInfo?.templateId || "",
      mapRegDttm: companyStampInfo?.mapRegDttm || "",

      // 도메인 및 URL 정보
      youtubeUrl: companyStampInfo?.youtubeUrl || "",
      instagramUrl: companyStampInfo?.instagramUrl || "",
      facebookUrl: companyStampInfo?.facebookUrl || "",
      hmpgUrl: companyStampInfo?.hmpgUrl || "",
      domainUrl: companyStampInfo?.domainUrl || "",

      // 추가 설정
      branchYn: companyStampInfo?.branchYn || "N",
      parentsComNm: companyStampInfo?.parentsComNm || "",
      dispYn: companyStampInfo?.dispYn || "N",
      dispSn: companyStampInfo?.dispSn || 0,
    },
  });

  /**
   * 폼 제출 핸들러 (아직 구현하지 않음)
   */
  const handleSubmit = () => {
    // TODO: 수정 요청 구현
    console.log("폼 제출이 준비되었습니다:", methods.getValues());
  };

  return {
    methods,
    handleSubmit: methods.handleSubmit(handleSubmit),
  };
}
